import React, {useEffect, useState} from 'react';

import {TableItems} from "components/pages/summary-table/table/table-items/TableItems";
import {useAppDispatch, useAppSelector} from "common/hook";
import {CustomPagination} from "components/pagination/CustomPagination";
import {Preloader} from "components/layout/preloader/Preloader";
import {NothingYetMessage} from "components/pages/personal-cabinet/nothing-yet-message/NothingYetMessage";
import {ItemSummaryTable} from "features/model/types/hr/getSummaryTable";
import {getSummaryTable} from "features/model/service/hr/get-summary-table/getSummaryTable";

export const Table = () => {
    const summaryTableData = useAppSelector(state => state.summaryTable);
    const dispatch = useAppDispatch();

    const {isLoading, success, data} = summaryTableData;
    const {pageCount, page, pageSize} = data.pagination;


    const onChangeHandle = (event: React.ChangeEvent<unknown>, value: number) => {
        dispatch(getSummaryTable({page: value - 1}));
    };

    return (
        <div className="data-tbl no-btn-link-col results-tbl data-tbl-border data-tbl-padding">
            <div className="row thead">
                <div className="col student-col">Студент <span>({data.count})</span></div>
                <div className="col current-level-col small-w">Начальный уровень</div>
                <div className="col planned-level-col">Текущий уровень</div>
                <div className="col start-classes-col">Начало занятий</div>
                <div className="col course-end-col">Прошедшие занятия</div>
                <div className="col radial-stat-col">Эффективность</div>
                <div className="col radial-stat-col">Посещаемость</div>
            </div>

            {isLoading ? (
                <Preloader/>
            ) : data.items && data.items.length > 0 ? (
                data.items.map((item: ItemSummaryTable, index) => (
                    <TableItems key={index} item={item}/>
                ))
            ) : (
                <NothingYetMessage/>
            )}

            {pageCount > 1 && (
                <CustomPagination pageCount={pageCount} currentPage={page + 1} onChangeHandle={onChangeHandle}/>
            )}

        </div>
    );
};
